export default __webpack_public_path__ + "static/media/hero-image.3f972f42.png";